import { Location } from "@/interfaces/location.ts";
import { Quickbooks, QuickbooksLocation } from "@/interfaces/quickbooks";
import { locationsService } from "@/services/locations.service";
import { messagesService } from "@/services/messages.service";
import { quickbooksService } from "@/services/quickbooks.service";
import cloneDeep from "lodash/cloneDeep";
import find from "lodash/find";
import { Validator } from "vee-validate";
import { Component, Inject, Prop, Provide, Vue } from "vue-property-decorator";
import Template from "./Quickbooks.template.vue";

@Component({
  mixins: [Template]
})
export default class QuickbooksComponent extends Vue {
  @Inject("$validator") public $validator!: Validator;
  @Provide() public validator = this.$validator;
  @Prop({ default: null }) public integrationsTab!: number;
  public loading: boolean = true;
  public quickbooks: Quickbooks | null = null;
  public initQuickbooks: Quickbooks | null = null;
  public getIntegrated: boolean = false;
  public disabledLocations: boolean = false;
  public loadingLocations: boolean = false;
  public locations!: Location[];
  public $st(translate: string) {
    return this.$t(`quickbooks.${translate}`);
  }

  public save() {
    const valid = this.validator.validate();
    if (!valid) {
      return;
    }
  }

  public async saveActivation(location: QuickbooksLocation) {
    const updateQuickbooks: Quickbooks = cloneDeep(this.quickbooks);
    updateQuickbooks![0].integrationByLocations = [location];
    if (this.quickbooks![0].id) {
      const newQuickbooks = await quickbooksService.saveIntegration(
        updateQuickbooks
      );
      this.quickbooks![0].integration_by_locations = cloneDeep(
        newQuickbooks.integration_by_locations
      );
      this.getLocations();
    }
  }

  public async changed(value: boolean) {
    this.loadingLocations = true;
    if (!this.quickbooks![0].id) {
      this.quickbooks![0] = await quickbooksService.quickbookEnabled(
        this.integrationsTab
      );
    } else {
      if (!value) {
        const locations = this.quickbooks![0].integration_by_locations;
        this.quickbooks![0].integration_by_locations = locations.map(loc => ({
          ...loc,
          is_active: false
        }));
      }
      (this
        .quickbooks as Quickbooks)![0].integrationByLocations = this.quickbooks![0].integration_by_locations;
      const newQuickbooks = await quickbooksService.saveIntegration(
        this.quickbooks!
      );
      this.quickbooks![0].integration_by_locations = cloneDeep(
        newQuickbooks.integration_by_locations
      );
    }
    this.getLocations();
    this.loading = false;
    this.loadingLocations = false;
    this.disabledLocations = value;
  }

  public get getShowConnect() {
    return !this.getIntegrated;
  }

  public async validIntegrated() {
    this.getIntegrated = await quickbooksService.verifyIntegration(
      this.integrationsTab
    );
  }

  public async connect() {
    this.loading = true;
    try {
      await quickbooksService.connect();
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }

  public revoke() {
    this.loading = true;
    quickbooksService
      .revoke(this.integrationsTab)
      .then(
        async () => await this.validIntegrated(),
        e => messagesService.renderErrorMessage(e)
      )
      .finally(() => (this.loading = false));
  }

  public getLocations() {
    this.quickbooks![0]!.integration_by_locations = this.locations.map(
      (item: Location): QuickbooksLocation => {
        let locationIntegreted = null;
        if (this.quickbooks && this.quickbooks.length) {
          locationIntegreted = find(
            this.quickbooks![0].integration_by_locations,
            ["location_id", item.id]
          );
        }
        if (!locationIntegreted) {
          return {
            location_id: item.id!,
            location: item,
            is_active: false
          };
        } else {
          return locationIntegreted;
        }
      }
    );
  }

  private async mounted() {
    await this.validIntegrated();
    this.locations = await locationsService.getAll();
    this.loading = true;
    try {
      this.initQuickbooks = await quickbooksService.getIntegration(
        this.integrationsTab
      );
      this.quickbooks = cloneDeep(this.initQuickbooks);
      if (!this.quickbooks!.length) {
        this.quickbooks![0] = {
          id: null,
          is_active: false,
          integration_by_locations: []
        };
      }
    } catch (e) {
      messagesService.renderErrorMessage(e);
    } finally {
      this.getLocations();
      this.disabledLocations = this.quickbooks![0].is_active;
      this.loading = false;
    }
  }
}
